import CT from '@marketplace-ai/tags';
import { useFormContext } from 'react-hook-form';
import { WizardFooter as SharedWizardFooter } from '~/components/Wizard/WizardFooter';
import { TrainingFormValues } from '../../types';
import { wizardPageDetails } from './constants';
const TAGS = CT.academics.training.wizard;

interface FooterProps {
  currentPage: number;
  form: Partial<TrainingFormValues>;
  wizardNext: (values: Partial<TrainingFormValues>) => void;
  wizardPrev: (values?: Partial<TrainingFormValues>) => void;
  wizardSubmit: (values: Omit<TrainingFormValues, 'id'>) => void;
  closeWizard: () => void;
  busy?: boolean;
}

export const WizardFooter = (props: FooterProps) => {
  const { currentPage, form, wizardNext, wizardPrev, wizardSubmit, closeWizard, busy } = props;
  const { trigger, handleSubmit: formSubmit, getValues, clearErrors } = useFormContext();

  const handleNext = async () => {
    if (await trigger()) {
      formSubmit((formValues) => {
        wizardNext(formValues);
      })();
    }
  };

  // [MCV-1214] Back navigation must not run RHF validation or it blocks users
  // whose current step has invalid fields. Clear surfaced errors before leaving.
  const handlePrev = () => {
    clearErrors();
    wizardPrev(getValues() as Partial<TrainingFormValues>);
  };
  const handleClose = () => closeWizard();

  const handleSubmit = async () => {
    if (await trigger()) {
      formSubmit((formValues) => {
        const values = { ...form, ...formValues };
        wizardSubmit(values as TrainingFormValues);
      })();
    }
  };

  return (
    <SharedWizardFooter
      backButton={
        currentPage != 0
          ? {
              label: 'Previous',
              cyTag: TAGS.prevBtn,
              onClick: handlePrev,
              disabled: busy,
            }
          : undefined
      }
      secondaryButton={{
        label: 'Close',
        cyTag: TAGS.closeBtn,
        onClick: handleClose,
        disabled: busy,
      }}
      primaryButton={
        currentPage != wizardPageDetails.length - 1
          ? {
              label: busy ? 'Saving…' : 'Next',
              cyTag: TAGS.nextBtn,
              onClick: handleNext,
              disabled: busy,
            }
          : { label: 'Submit', cyTag: TAGS.submitBtn, onClick: handleSubmit }
      }
    />
  );
};
